import * as React from 'react';
import { Icon } from '../../../icons/Icons';
import { Flex } from '../../../compositeComponents/FlexHelpers';
import { colors } from '../../../colors/color';
import { Label } from '../../../Label';

export function EnvironmentBanner():JSX.Element
{
    const hostname = document.location.hostname;
    let env: 'test' | 'localhost' | 'other' = 'other';

    if (hostname === 'apptest.amorg.dk') {
        env = 'test';
    } else if (hostname === 'localhost') {
        env = 'localhost';
    }

    return (
        <>
            {(env === 'test' || env === 'localhost') &&
                <Flex justifyContent='center' gap={8}>
                    <Icon name='construction' color={colors.icon.warning} />
                    <Label>
                        {env}
                    </Label>
                </Flex>
            }
        </>
    );
}